import React from 'react';
import './item-view-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import ImageContainer from '../image-container/image-container.component';
import { properCase } from '@/utils/properCase';

const ItemViewModal = ({
    item,
    cancel
}) => {
    return (
        <div className='item-view-modal'>
            { 
                (item) &&
                <Modal
                    show={item}
                    cancel={cancel}
                    closeButton={true}
                    text={item.data.name} >
                    <div className={`item-view-modal-content ${item.id.includes('header') ? 'header' : ''}`}>
                        <div className='image'>
                            <ImageContainer
                                src={item.data.url} />
                        </div>
                        <div className='content'>
                            <div className=''>
                                <span className='meta'>Name</span>: {item.data.name}
                            </div>
                            <div className=''>
                                <span className='meta'>Type</span>: {properCase(item.data.type)}
                            </div>
                            {
                                (item.data.desc) &&
                                <div className=''>
                                    <span className='meta'>Description</span>: {item.data.desc}
                                </div>
                            }
                            {
                                Object.keys(item.data).map(s => {
                                    const setting = (item.data[s]);
                                    if (!s.includes('opt_') || setting === false) return;
                                    return (
                                        <div key={s} className=''>
                                            <span className='meta'>{properCase(s.replace('opt_', ''))}</span>: {
                                                setting === true 
                                                ? 'TRUE' 
                                                : setting === false 
                                                ? 'FALSE' 
                                                : setting
                                            }
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                </Modal>
            }
        </div>
    )
}

export default ItemViewModal